import http from '@/api/common'

export default {
  // Get all business profiles or a specific profile by ID
  getBusinessProfiles(id) {
    if (id) {
      return http.get(`BusinessProfile/GetBusinessProfile?id=${id}`)
    }
    return http.get('BusinessProfile/GetBusinessProfile')
  },

  // Create or update a business profile
  upsertBusinessProfile(data) {
    return http.post('BusinessProfile/UpsertBusinessProfile', data)
  },

  // Delete a business profile
  deleteBusinessProfile(id) {
    return http.delete(`BusinessProfile/DeleteBusinessProfile?id=${id}`)
  },

  // Clone an existing business profile
  cloneBusinessProfile(data) {
    return http.post('BusinessProfile/CloneBusinessProfile', data)
  },

  // Add or update a product in a business profile
  upsertBusinessProfileProduct(data) {
    return http.post('BusinessProfile/UpsertBusinessProfileProduct', data)
  },

  // Add or update a product addon in a business profile
  upsertBusinessProfileProductAdd(data) {
    return http.post('BusinessProfile/UpsertBusinessProfileProductAdd', data)
  },

  // Remove a product from a business profile
  deleteBusinessProfileProduct(businessProfileId, productId) {
    return http.delete(
      `BusinessProfile/DeleteBusinessProfileProduct?businessProfileId=${businessProfileId}&productId=${productId}`
    )
  },

  // Remove a product addon from a business profile
  deleteBusinessProfileProductAdd(businessProfileId, productAddId) {
    return http.delete(
      `BusinessProfile/DeleteBusinessProfileProductAdd?businessProfileId=${businessProfileId}&productAddId=${productAddId}`
    )
  },

  // Apply a business profile to a business
  applyBusinessProfile(data) {
    return http.post('BusinessProfile/ApplyBusinessProfile', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/business-profile.js